import { ADDON_ID, constants_default } from './chunk-JT3VIYBO.mjs';
import { addons } from '@storybook/manager-api';

addons.register(ADDON_ID,api=>{addons.getChannel().on(constants_default.REQUEST,({kind,name})=>{let id=api.storyId(kind,name);api.emit(constants_default.RECEIVE,id);});});
